import React from 'react';
import { NavLink } from 'react-router-dom';

import { Form } from '../../../../components';

const Component = ({ form, state, isNew, handlers }) => (
  <div className="col-md-6">
    <div className="card">
      <div className="card-header border-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title">{isNew ? 'Create new MAC' : 'Edit MAC'}</h5>
          <div>
            <NavLink className="btn btn-round btn-warning" to={`/macs`}>
              <i className="nc-icon nc-minimal-left"/>
            </NavLink>
          </div>
        </div>
      </div>
      <Form.Progress on={state.pending} />
      <Form.Messages form={form} state={state} onClose={handlers.onReset} />
      <div className="card-body">
        <form onSubmit={form.handleSubmit(handlers.onSubmit)} onChange={handlers.onReset}>
          <label>MAC</label>
          <div className="form-group">
            <input name="mac" ref={form.register} maxLength={17} className="form-control" placeholder="Enter MAC"/>
          </div>
          <label>Note</label>
          <div className="form-group">
            <textarea name="note" ref={form.register} maxLength={255} className="form-control" placeholder="Enter note"/>
          </div>
        </form>
      </div>
      <div className="card-footer border-top">
        <Form.Submit form={form} state={state} label="Save" onSubmit={form.handleSubmit(handlers.onSubmit)} />
      </div>
    </div>
  </div>
);

export default Component;
